<template>
  <component :is="tagName(tagSpec(tagSpecs, 0))"
             :class="tagClasses(tagSpec(tagSpecs, 0))"
  >{{ seconds | time }}
  </component>
</template>

<script>

export default {

  props: {
    tagSpecs: {
      type: String,
      default: "span"
    }
  },

  computed:{
    seconds: function (){
      return this.$read('timer');
    }
  }
}
</script>